import request from '@/utils/request'
const recruitServer = ''

/** 导入 */
export function uploadFile (data) {
  return request({
    url: `${recruitServer}/common/uploadFile`,
    'content-type': 'multipart/form-data',
    method: 'post',
    data
  })
}
/** 下载 */
export function downloadFile (data) {
  return request({
    url: `${recruitServer}/common/downloadFile`,
    method: 'post',
    data
  })
}
/** 删除 */
export function deleteFile (data) {
  return request({
    url: `${recruitServer}/common/deleteFile`,
    method: 'post',
    data
  })
}
/** 下载-文件流格式 */
export function downloadFileBlob (data) {
  return request({
    url: `${recruitServer}/common/downloadFile`,
    method: 'post',
    responseType: 'blob',
    data
  })
}
/** 临时预览文件链接 */
export function proviewFileOld (fileCode, fileToken) {
  return request({
    url: `${recruitServer}/common/proviewFile?fileCode=${fileCode}&fileToken=${fileToken}`,
    method: 'post'
  })
}

export function proviewFile (fileCode, fileToken) {
  const getAvatarImg = async function (row) {
   if (row && row.fileCode && row.fileToken) {
     const param = {
       fileCode: row.fileCode,
       fileToken: row.fileToken
     }
     const url = await downloadFileBlob(param)
     return url
   } else {
     return ''
   }
 }

 return new Promise((resolve) => {
   if (!fileToken) {
     return resolve('')
   }
   getAvatarImg({ fileCode, fileToken }).then(res => {
     const reader = new FileReader()
     reader.readAsDataURL(res)
     reader.onload = () => {
       resolve(reader.result)
     }
   })
 })
}
